import modelRequest, { RequestError } from './lib/modelRequest'

interface ProbeDetails {
  title: string
  link: string
}

interface SelectedProbe {
  phonics: ProbeDetails
  phrases: ProbeDetails
}

export default {
  /**
   * Gets the probes selected by the teacher
   */
  get: (): Promise<SelectedProbe & RequestError> => {
    return modelRequest.get('/api/students/student-probes')
  },
}
